export const SPANISH_TRANSLATIONS = {
	menu: {
		return: 'Regresar al menú',
		logOut: 'Cerrar sesión'
	}
};
